import { Col, Image, Row, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ContactPagemap from "../../../assets/images/ContactPagemap.png";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import useContactPageInfos from "../../../hooks/global/useContactPageInfos";
import usePublicPageSeo from "../../../hooks/global/usePublicPageSeo";
import { APP_DOMAIN } from "../../../utls/constants";
import "./index.less";
const { Title, Paragraph } = Typography;

const ContactPage = () => {
  const { t } = useTranslation();
  useContactPageInfos(t);
  usePublicPageSeo({ path: "/contact" });

  return (
    <div className="PolicyPagesCommonWrapper">
      <HomePageNavbarComponent />
      <h1 className="seo-hidden">Contactez Twizz</h1>
      <Row justify="center" className="ContactPageWrapper">
        <Row className="contact-child-main">
          <Title level={2} className="contact-child-title">
            Nous sommes à différents endroits
          </Title>
          <Paragraph className="contact-child-paragraph">{t("we-have-offices-and-teams-around-the-world")}</Paragraph>

          <Row className="ImageContainer">
            <Image src={ContactPagemap} alt="img not available" preview={false} className="contact-child-img" />
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Montreal</span>} color="#fff">
              <div className="circleWrapper point-1">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Brussels</span>} color="#fff">
              <div className="circleWrapper point-2">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Wilmington</span>} color="#fff">
              <div className="circleWrapper point-3">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>San Francisco</span>} color="#fff">
              <div className="circleWrapper point-4">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
          </Row>
        </Row>
        <Row className="contact-child-main2" gutter={16}>
          <Col className="contact-child-col">
            <Title level={2} className="contact-child-text1">
              Support
            </Title>
            <Paragraph className="contact-child-text2">{t("our-team-is-here-to-help-you")}</Paragraph>
            <Link to={"/hello"} className="contact-child-link">
              contact@{APP_DOMAIN}
            </Link>
          </Col>
          <Col className="contact-child-col">
            <Title level={2} className="contact-child-text1">
              Créateurs
            </Title>
            <Paragraph className="contact-child-text2">{t("questions-contact-us-text")}</Paragraph>
            <Link to={"/hello"} className="contact-child-link">
              creators@{APP_DOMAIN}
            </Link>
          </Col>
        </Row>
      </Row>
      {/* SEO: Link for crawlers */}
      <details>
        <summary style={{ listStyle: "none" }}></summary>
        <a href="/profiles">Creator Profiles</a>
      </details>
    </div>
  );
};

export default ContactPage;
